import { Component, inject } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { FormsModule } from '@angular/forms';
import { AuthStore } from 'src/app/stores/auth.store';
import { ModalBaseComponent } from 'src/app/shared/components/modal-base/modal-base.component';
export interface optionalMarketingInfo {
  agreedMarketingContact: boolean;
}

@Component({
  selector: 'app-optional-sso-info-modal',
  imports: [MatTooltipModule, TranslateModule, FormsModule, ModalBaseComponent],
  templateUrl: './optional-sso-info-modal.component.html',
})
export class OptionalSsoInfoModalComponent {
  protected dialogRef = inject(DialogRef);
  protected authStore = inject(AuthStore);
  protected data = inject(DIALOG_DATA);
  public agreedMarketingContact = true;
  public signupReference = '';

  confirmAction() {
    this.dialogRef.close({
      agreedMarketingContact: this.agreedMarketingContact,
      signupReference: this.signupReference,
    });
  }
}
